import { TeamConfigGroup } from '../model/Team';
import { StaticMemberConfig } from '../model/TeamMember';

export const teamMembers: StaticMemberConfig[] = [
  {
    key: 'tomas',
    photo: 'tomas.webp',
    email: 'tomas.kourim@mild.blue',
    phone: '+420 723 927 536',
  },
  {
    key: 'honza',
    photo: 'honza.webp',
  },
  {
    key: 'lubomir',
    photo: 'lubomir.webp',
  },
  {
    key: 'viktor',
    photo: 'viktor.webp',
  },
  {
    key: 'kuba',
    photo: 'kuba.webp',
  },
  {
    key: 'skalahonza',
    photo: 'skalahonza.webp',
    email: 'jan.skala@mild.blue',
  },
  {
    key: 'pavel',
    photo: 'pavel.webp',
  },
  {
    key: 'nasta',
    photo: 'nasta.webp',
    email: 'anastasia.surikova@mild.blue',
  },
  {
    key: 'iva',
    photo: 'iva.webp',
  },
  {
    key: 'zuzana',
    photo: 'zuzana.webp',
  },
  {
    key: 'marta',
    photo: 'marta.webp',
  },
  {
    key: 'jabor',
    photo: 'jabor.png',
  },
  {
    key: 'kotrbaty',
    photo: 'kotrbaty.jpg',
  },
  {
    key: 'zamecnik',
    photo: 'zamecnik.jpg',
  },
  {
    key: 'straka',
    photo: 'straka.jpg',
  },
];

export const teamGroups: TeamConfigGroup[] = [
  {
    key: 'mildblue',
    memberKeys: ['tomas', 'kuba', 'lubomir', 'marta', 'viktor', 'iva', 'honza', 'skalahonza', 'pavel', 'zuzana'],
  },
  {
    key: 'cooperation',
    memberKeys: ['jabor', 'kotrbaty', 'zamecnik', 'straka'],
  },
];
